module.exports = __webpack_public_path__ + "static/media/loc1_img24.2a01e6c3.jpg";